import React, {useState} from "react";
import {Link} from "react-router-dom";
import Logo from "../images/logo/ezcarrentals-Newlogo.png";
import { suburbs, getSuburbPath, isSuburbLive } from "../data/suburbs";

function Navbar() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isSuburbsOpen, setIsSuburbsOpen] = useState(false);

    const toggleMobileMenu = () => {
        if (isMobileMenuOpen) {
            setIsSuburbsOpen(false);
        }
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };
    const handleServiceClick = () => {
        navigateAndScroll(".pick-container");
    };

    const handleTestimonialsClick = () => {
        navigateAndScroll(".testimonials-section");
    };


    const handleContactusClick = () => {
        navigateAndScroll(".contact-page");
    };

    const navigateAndScroll = (selector) => {
        if (window.location.pathname !== "/") {
            window.location.assign("/");
            const onHomeLoad = () => {
                setTimeout(() => {
                    scrollToElement(selector);
                }, 100);
                window.removeEventListener("load", onHomeLoad);
            };
            window.addEventListener("load", onHomeLoad, { once: true });
        } else {
            setTimeout(() => {
                scrollToElement(selector);
            }, 100);
        }
    };


    const scrollToElement = (selector) => {
        const element = document.querySelector(selector);
        if (element) {
            element.scrollIntoView({behavior: "smooth"});
        }
    };

    return (
        <>


      <nav>
        

        {/* desktop */}

          <div className='navbar__content'>
           <div className='top-bar'>
               <p>LIMITED AVAILABILITY. SECURE YOUR VEHICLE TODAY</p>

           </div>
            <div className='navbar'>
                <div className='navbar__img'>
            <Link to='/' onClick={() => window.scrollTo(0, 0)}>
              <img src={Logo} alt='logo-img'/>
            </Link>
          </div>
                <ul className='navbar__links'>
            <li>
              <Link
                  className='home-link'
                  to='/'
                  onClick={() => window.scrollTo(0, 0)}
              >
                Home
              </Link>
            </li>
            <li>
              <Link className='about-link' to='/' onClick={handleServiceClick}>
                Our Services
              </Link>
            </li>
            <li>
              {" "}
                <Link to='/' onClick={handleTestimonialsClick}>
                Testimonials
              </Link>
            </li>
                     <li>
              <Link className='ezrent-to-own' to='/ezrent-to-own'  >
             Rent To Own
              </Link>
            </li>
            <li>
              <Link to='/request-quote' onClick={() => window.scrollTo(0, 0)}>
                Request a Quote
              </Link>
            </li>
            <li>
              {" "}
                <Link to='/' onClick={handleContactusClick}>
                Contact us
              </Link>
            </li>
            <li>
              <Link to='/about-us'>About Us</Link>
            </li>
            <li>
              <Link to='/blog'>Blogs</Link>
            </li>
            <li className='navbar__dropdown'>
              <Link
                to='/suburbs'
                className='navbar__dropdown-toggle'
                aria-haspopup='true'
              >
                Suburbs
              </Link>
              <div className='navbar__dropdown-menu'>
                <Link to='/suburbs' className='navbar__dropdown-all'>
                  View All Suburbs
                </Link>
                <div className='navbar__dropdown-grid'>
                  {suburbs.map((suburb) => (
                    <Link
                      key={suburb.slug}
                      to={getSuburbPath(suburb.slug)}
                      className={`navbar__dropdown-link ${
                        isSuburbLive(suburb.slug) ? "is-live" : "is-soon"
                      }`}
                    >
                      <span>{suburb.name}</span>
                      <span className='navbar__dropdown-tag'>
                        {isSuburbLive(suburb.slug) ? "Live" : "Soon"}
                      </span>
                    </Link>
                  ))}
                </div>
              </div>
            </li>
          </ul>
                <button
                  type='button'
                  className='hamburger'
                  onClick={toggleMobileMenu}
                  aria-label='Toggle navigation menu'
                  aria-expanded={isMobileMenuOpen}
                >
            <span></span>
            <span></span>
            <span></span>
          </button>
            </div>

        </div>

          {/* *******************************mobile menu************************************************** */}

          <ul className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          <li>
            <Link to='/' onClick={() => {
                setIsMobileMenuOpen(false);
                window.scrollTo(0, 0);
            }}>
              Home
            </Link>
          </li>
          <li>
            <Link to='/' onClick={() => {
                setIsMobileMenuOpen(false);
                handleServiceClick();
            }}>
              Our Services
            </Link>
          </li>
          <li>
            <Link to='/' onClick={() => {
                setIsMobileMenuOpen(false);
                handleTestimonialsClick();
            }}>
              Testimonials
            </Link>
          </li>
          <li>
            <Link to='/ezrent-to-own' onClick={() => setIsMobileMenuOpen(false)}>
              Rent To Own
            </Link>
          </li>
          <li>
            <Link to='/request-quote' onClick={() => setIsMobileMenuOpen(false)}>
              Request a Quote
            </Link>
          </li>
          <li>
            <Link to='/' onClick={() => {
                setIsMobileMenuOpen(false);
                handleContactusClick();
            }}>
              Contact us
            </Link>
          </li>
          <li>
            <Link to='/about-us' onClick={() => setIsMobileMenuOpen(false)}>
              About Us
            </Link>
          </li>
          <li>
            <Link to='/blog' onClick={() => setIsMobileMenuOpen(false)}>
            Blog
            </Link>
          </li>
          <li className='mobile-submenu'>
            <button
              type='button'
              className='mobile-submenu__toggle'
              onClick={() => setIsSuburbsOpen(!isSuburbsOpen)}
              aria-expanded={isSuburbsOpen}
            >
              Suburbs
            </button>
            {isSuburbsOpen && (
              <ul className='mobile-submenu__list'>
                <li>
                  <Link to='/suburbs' onClick={() => setIsMobileMenuOpen(false)}>
                    View All Suburbs
                  </Link>
                </li>
                {suburbs.map((suburb) => (
                  <li key={suburb.slug}>
                    <Link
                      to={getSuburbPath(suburb.slug)}
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      {suburb.name}
                      <span className={`mobile-submenu__tag ${isSuburbLive(suburb.slug) ? "is-live" : "is-soon"}`}>
                        {isSuburbLive(suburb.slug) ? "Live" : "Soon"}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        </ul>
          {/* ********************************************************************************* */}


      </nav>
    </>
    );
}

export default Navbar;
